import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/cmnty/qna`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/cmnty/qna/qna-mgmt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0310001q: `${BASE.path}/ptli0310001q`, // List of roles                           !== 역할 관리 목록 ==!
    ptli0310001s: `${BASE.path}/ptli0310001s`, // Register for Role Management            !== 역할 관리 등록 ==!
    //ptli1004003s: `${BASE.path}/ptli1004003s`, // Modifying and deleting role management  !== 역할 관리 수정 및 삭제 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View a list of roles  !== 역할 목록 조회 ==!
    getQnaList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // View role information  !== 역할 정보 조회 ==!
    getQnaInfo: (id: any) => api.get(`${BASE.api}/${id}`),
};

export const SF_FAQ_MGMT_SRCH: TFormSchema = {
    id: "form_ptli1004001qSrch",
    schema: {
        //roleNm: { type: "select", label: "System Category" },

        sysCat: {
            all: true,
            type: "select",
            label: "System Category",
            labelSize: 2,
            controlSize: 4,
            options: [
                { label: "IPT", value: "1" },
                { label: "EPT", value: "2" },
                { label: "OGA", value: "3" },
            ],
        },
        boardTitle: { type: "text", label: "Title" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "strtDt" },
            end: { name: "endDt" },
        },

        //boardId: { type: "select", label: "L_FAQ_ID" },
        //boardTitle: { type: "select", label: "L_FAQ_TITLE" },

        faq: { type: "text", label: "Service Code" },
    },
};

export const SF_PTLI0310001S: TFormSchema = {
    id: "form_ptli0310001s",
    schema: {
        //boardId: { type: "text", label: "L_FAQ_ID" },\
        faq: { type: "text", label: "L_FAQ_FAQ" },
        boardTitle: { type: "text", label: "L_FAQ_TITLE" },
        boardNo: { type: "text", label: "L_FAQ_NO" },
        boardContent: { type: "text", label: "L_SYS_CAT" },
        attachment: { type: "text", label: "L_ATTACHMENT" },
        sysCat: { type: "text", label: "L_SYS_CAT" },
        boardContet: { type: "text", label: "L_FAQ_CONTENT" },
        boardPublic: { type: "text", label: "L_FAQ_PUBLIC" },
        //roleDesc: { type: "text", label: "L_ROLE_DESC" },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "text", label: "L_FRST_RGSR_DTM" },
    },
};

export const SG_FAQ_MGMT_LIST: TGridSchema = {
    id: "grid_ptli0310001q",
    options: { pagination: "out", edit: false, index: true },
    head: [
        //{ cells: [{ header: "L_FAQ_NO", binding: "boardNo", width: "*" }] },
        { cells: [{ header: "L_FAQ_FAQ", binding: "faq", width: "*" }] },
        { cells: [{ header: "L_FAQ_TITLE", binding: "boardTitle", width: "*" }] },
        { cells: [{ header: "L_ATTACHMENT", binding: "attachment", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: 150 }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: 150 }] },
    ],
    body: [
        //{ cells: [{ binding: "boardNo", edit: false, align: "left" }] },
        { cells: [{ binding: "faq", edit: false, align: "left" }] },
        { cells: [{ binding: "boardTitle", edit: false, align: "left" }] },
        { cells: [{ binding: "attachment", edit: false, align: "left" }] },

        {
            cells: [{ binding: "frstRegstId" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm" }],
        },
    ],
};
